import React, { useState, useEffect } from 'react';
import MockupsFilter from './MockupsFilter';
import MockupsTable from './MockupsTable/index';
import { Container } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store/index';
import ConfigMockup from './ConfigMockup';
import Skeleton from 'react-loading-skeleton';
import { setEditingMockup } from '../../../../store/ducks/fabrication-mockups/actions';
import { IFabricationMockup } from '../../../../store/ducks/fabrication-mockups/types';

const Mockups: React.FC = () => {
  const dispatch = useDispatch();

  const mockupState = useSelector(
    (appstate: ApplicationState) => appstate.fabricationMockups
  );
  const contractNumber = mockupState.contractNumber;
  const isLoading = useSelector(
    (appstate: ApplicationState) => appstate.fabricationMockups.loading
  );
  const [filteredMockups, setFilteredMockups] = useState<IFabricationMockup[]>(
    mockupState.mockups || []
  );
  const mockups = mockupState.mockups;

  const [searchInput, setSearchInput] = useState('');
  const [canShowConfigModal, setCanShowConfigModal] = useState(false);

  const onNewMockupClick = () => {
    if (mockupState.saveMockupState?.editingMockupId) {
      dispatch(setEditingMockup());
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setCanShowConfigModal(true);
  };

  useEffect(() => {
    if (mockupState.mockups) {
      setFilteredMockups(mockupState.mockups);
    }
  }, [mockupState.mockups]);

  return (
    <Container>
      <div>
        {!isLoading && !!contractNumber && (
          <>
            <MockupsFilter
              mockupsState={mockupState}
              filteredMockups={filteredMockups}
              setFilteredMockups={setFilteredMockups}
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              onNewMockupClick={onNewMockupClick}
              onCleanFilters={() =>
                setFilteredMockups(mockupState.mockups || [])
              }
            />

            <MockupsTable
              contractNumber={contractNumber}
              filteredMockups={filteredMockups}
              searchTerm={searchInput}
            />
          </>
        )}
        {isLoading && <Skeleton count={6} style={{ margin: '0.5rem 0' }} />}
      </div>
      {canShowConfigModal && !!contractNumber && (
        <ConfigMockup
          allMockupNames={mockups.map((m) => m.name)}
          contractNumber={contractNumber}
          onCancel={() => setCanShowConfigModal(false)}
        />
      )}
    </Container>
  );
};

export default Mockups;
